import { render, staticRenderFns } from "./questionbankUpload.vue?vue&type=template&id=5f5a6cce"
import script from "./questionbankUpload.vue?vue&type=script&lang=js"
export * from "./questionbankUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports